module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    staticClass: "alert",
    class: _vm.classes
  }, [(!_vm.hideIcon) ? _c('v-icon', {
    staticClass: "alert__icon"
  }, [_vm._v(_vm._s(_vm.mdIcon))]) : _vm._e(), _c('div', [_vm._t("default")], 2), (_vm.dismissible) ? _c('a', {
    staticClass: "alert__dismissible",
    attrs: {
      "href": "#!"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('input', false)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "right": "right"
    }
  }, [_vm._v("cancel")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-696bfbfc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/alerts/Alert.vue
// module id = 117
// module chunks = 0